<template>
	<div class="secondpage">
		<div class="title_top">
			<el-row :gutter="20">
				<el-col :span="16" :offset="4">
					<div class="secondpage_con">
						<h2>关于我们</h2>
						<p>根据具体项目需求提供相关技术支持</p>
					</div>
				</el-col>
			</el-row>
		</div>
		<!-- 内容 -->
		<!-- 布局 -->

		<el-row>
			<el-col :span="16" :offset="4">
				<el-row>
					<el-col :xs="24" :sm="8">
						<div class="lefttitle">
							<h2>About Us</h2>
							<p>公司简介</p>
						</div>
					</el-col>
					<el-col :xs="24" :sm="16">
						<p>
              广州锐动网络科技有限公司是一家互联网技术服务商，可根据具体项目需求，提供网站与业务系统开发、系统对接、部署及运维等技术支持。
						</p>
						<p>
              根据具体项目需求，可提供方案设计、开发实施及上线相关技术支持。客户使用的相关资源由客户自行选定的第三方服务商提供，我们不经营相关资源；具体服务内容及责任范围以双方约定为准。
						</p>
					</el-col>
				</el-row>
			</el-col>
		</el-row>


		<el-row>
			<div class="yunduanfuwu">
				<el-col :span="16" :offset="4">
					<el-row>
						<el-col :xs="24" :sm="12">
							<h1>企业信息化服务</h1>
							<h1>提供项目技术支持</h1>
							<p>可根据具体项目约定，提供第三方平台选型建议、系统设计、部署及运维相关技术支持</p>
							<el-button round>
								<router-link :to="{path:'/solution',query: {id: 2}}">查看服务</router-link>
							</el-button>
						</el-col>
						<el-col :xs="0" :sm="12">
						</el-col>
					</el-row>
				</el-col>
			</div>
		</el-row>

	</div>
</template>

<script>
	export default {
		data() {
			return {
				workTask: []
			};
		},
		created() {
			this.workTask = this.$route.query.id
			console.log(this.workTask)
		},
		beforeMount: function() { //挂载前状态

		}

	}

</script>

<style scoped>
	* {

		color: #000000;
	}

	.title_top {

		width: 100%;
		overflow: hidden;
		margin: 0;
		color: #000000;
		background: url(../assets/1587_jgzynhtp.jpg) no-repeat center center;
		-webkit-background-size: cover;
		-moz-background-size: cover;
		-o-background-size: cover;
		background-size: cover;
	}

	.secondpage_con {
		margin: 150px auto;

	}

	.secondpage_con h1,
	.secondpage_con p,.secondpage_con h2{
		color: #FFFFFF;
	}

	.el-row {
		/* margin-top: 60px ; */
	}

	.lefttitle {
		text-align: left;
	}

	.yunduanfuwu {
		text-align: left;
		width: 100%;
		overflow: hidden;
		padding-top: 50px;
		padding-bottom: 50px;
		color: #FFFFFF;
		background: url(../assets/1587_jh5pkdw8.jpg) no-repeat center center;
		-webkit-background-size: cover;
		-moz-background-size: cover;
		-o-background-size: cover;
		background-size: cover;
	}

	.yunduanfuwu h1,
	.yunduanfuwu p {
		color: #FFFFFF;
	}

	.yunduanfuwu button {
		color: #0286e6;
	}
	.yunduanfuwu button a {
		color: #0286e6;
	}


	.el-carousel__item {
		background-color: #FFFFFF;
		box-shadow: 3px 3px 10px #f5f5f5;

	}

	.el-carousel__item .el-button {
		border-color: #249dc3;
		color: #249dc3;
	}
	.hezuohuoban{
		width: 100%;
		height: 100%;
		background-color: rgb(248, 248, 248);
	}
</style>



// WEBPACK FOOTER //
// src/components/about.vue